var utils = require('util');
var View = require('./View');
var PartCache = require('../Models/PartCache');

var ElementView = module.exports = function(model) {
    this.init(model);
    this.initView();
    this.cache = new PartCache();
};

utils.inherits(ElementView, View);

ElementView.prototype.init = function(model) {
    this.model3D = [];
    this.model = model;

    this.scalePanelOffset = 30;
};

ElementView.prototype.setScalePanelOffset = function(offset) {
    this.scalePanelOffset = offset;

    return this;
};

ElementView.prototype.getModel3D = function() {
    return this.model3D;
};

ElementView.prototype.setModel3D = function(model3D) {
    this.model3D = model3D;

    return this;
};

ElementView.prototype.getModel = function() {
    return this.model;
};

ElementView.prototype.setModel = function(model) {
    this.model = model;

    return this;
};

ElementView.prototype.loadModel3D = function() {
    throw "method needs to be overwritten";
};




// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Views/ElementView.js